if (!customElements.get('installation-nav')) {
  class InstallationNav extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleScrollRef = this.handleScroll.bind(this);
    }

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.top > 0
      );
    }

    handleClick(event) {
      event.preventDefault();

      const target = document.querySelector(
        `[data-id="${event.target.getAttribute('data-target')}"]`,
      );

      if (!target) return;

      window.scrollTo({
        top: target.offsetTop - 100,
        left: 0,
        behavior: 'smooth',
      });
    }

    handleScroll(event) {
      this.hasElementInViewport = false;

      this.sections.forEach(({ anchor, section }) => {
        if (this.hasElementInViewport) return;
        if (anchor.classList.contains('is-active')) return;
        if (this.isInViewport(section)) {
          window.setTimeout(() => {
            this.querySelector('.is-active')?.classList.remove('is-active');
            anchor.classList.add('is-active');
          }, 50);

          this.hasElementInViewport = true;
        }
      });

      this.hasElementInViewport = false;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
      window.removeEventListener('scroll', this.handleScrollRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
      window.addEventListener('scroll', this.handleScrollRef);

      this.sections = [];

      this.querySelectorAll('a').forEach((a) => {
        this.sections.push({
          anchor: a,
          section: document.querySelector(
            `[data-id="${a.getAttribute('data-target')}"]`,
          ),
        });
      });

      this.handleScroll();
    }
  }

  customElements.define('installation-nav', InstallationNav);
}
